module.exports = __webpack_public_path__ + "89c9af5da44c2a5ed6c3831d35391259.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@deere/cps-it.warranty-base-styles/icons/svg/sorted.svg
// module id = 119
// module chunks = 0